'use strict';

require('../../helpers/users/users.module');

angular.module('far.models.ascents', ['far.helpers.users'])
	.service('Ascents', function($log, $http, usersHelper) {
		var list = [],
			firstListQuery = true,
			listQueryProgress = false;

		Object.defineProperty(this, 'list', {
			get: function() {
				if (firstListQuery && !listQueryProgress) {
					listQueryProgress = true;

					$http.get(Routing.generate(''))
						.then(function(response) {
							response.data.forEach(function(routeData) {
								list.push(new Ascent(routeData));
							});

							firstListQuery = false;
							listQueryProgress = false;
						})
						.catch(function(response) {
							listQueryProgress = false;
							$log.error(response);
						});
				}

				return list;
			}
		});

		this.new = function(ascentData, userTypes) {
			return new Ascent(ascentData, userTypes);
		};

		this.delete = function(ascent, callback) {
			return $http.delete(Routing.generate('api_entities_delete_ascent', {ascent: ascent.id}))
				.then(function() {
					ascent = null;

          if (typeof callback == 'function') {
              callback();
          }
				})
				.catch(function(response) {
					$log.error(response);
				});
		};

		this.restore = function(ascent, callback) {
			return $http.patch(Routing.generate('api_entities_patch_ascent', {id: ascent.id}))
				.then(function() {
					if (typeof callback == 'function') {
						callback(ascent);
					}
				})
				.catch(function(response) {
					$log.error(response);
				});
		};

		this.get = function(ascentId, userTypes, callback) {
			var route = new Ascent({}, userTypes);

			$http.get(Routing.generate('api_entities_get_ascent', {ascent: ascentId}))
				.then(function(response) {
                    var chief = true,
						instructor = true;

                    angular.forEach(response.data.ascent_users, function (user) {
                        if(user.ascent_user_type_id.system_name == 'chief') {
                            chief = false;
                        }
                        if(user.ascent_user_type_id.system_name == 'instructor') {
                            instructor = false;
                        }
                    });

                    if (chief) {
                        response.data.ascent_users.push({
                            ascent_user_type_id: userTypes.chief
                        });
                    }

                    if(instructor){
                    	response.data.ascent_users.push({ascent_user_type_id: userTypes.instructor});
					}

					route.update(response.data);

					if (typeof callback == 'function') {
						callback(route);
					}
				})
				.catch(function(response) {
					$log.error(response);
				});

			return route;
		};



		function Ascent(ascentData, userTypes) {
			this.ascent_users = [];
			this.documents_files = [];
			angular.merge(this, ascentData);

			Object.defineProperty(this, 'update', {
				enumerable: false,
				get: function() {
					return function(ascentData) {
						angular.merge(this, ascentData);
						this.updateUsers();

						return this;
					}
				}
			});

			Object.defineProperty(this, 'save', {
				enumerable: false,
				get: function() {
					return function() {
						var method = this.id ? 'put' : 'post',
								url = this.id ?
									Routing.generate('api_entities_put_ascent', {ascent: this.id}) :
									Routing.generate('api_entities_post_ascent');
						var data = angular.extend({}, this);

						data.ascent_users = data.ascent_users.filter(function (user) {
							if (user.user) {
								return true;
							}
						});

						data.ascent_mountain_route = data.ascent_mountain_route.id;

						if (angular.isObject(data.ascent_type)) {
							data.ascent_type = data.ascent_type.id;
						}

						angular.forEach(data.documents_files, function(document_file, i) {
							data.documents_files[i]=document_file.id;
						});

						return $http[method](url, data);
					}
				}
			});
			usersHelper.initUsers(this, userTypes, 'ascent_users', 'ascent_user_type_id');
			this.createUser(this.userTypes.chief);
			this.createUser(this.userTypes.instructor);
		}
	});
